import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col md:static w-full h-auto lg:h-full min-h-full bg-white overflow-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_nav = _resolveComponent("header-nav")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_footer_section = _resolveComponent("footer-section")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_header_nav),
    _createElementVNode("div", {
      class: _normalizeClass([
        'overflow-auto lg:overflow-hidden',
        'bg-white',
        $setup.filteredBreadcrumb.length > 0 ?
          'h-auto min-h-[calc(100%_-_103px)] md:min-h-[calc(100%_-_182px)] lg:min-h-[calc(100%_-_111px)] lg:h-[calc(100%_-_111px)]'
          : 'h-auto min-h-[calc(100%_-_71px)] md:min-h-[calc(100%_-_142px)] lg:min-h-[calc(100%_-_71px)] lg:h-[calc(100%_-_71px)]',
      ])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass([
          'h-auto min-h-[calc(100%_-_100px)] md:min-h-[calc(100%_-_40px)] lg:h-[calc(100%_-_40px)]',
        ])
      }, [
        _createVNode(_component_router_view)
      ], 2),
      _createVNode(_component_footer_section)
    ], 2)
  ]))
}